var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 8.69 14.8",
    fill: "#d1d3d4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,7.4A.78.78,0,0,0,.24,8l6.59,6.59a.8.8,0,0,0,1.14,0l.49-.48a.83.83,0,0,0,.23-.58.81.81,0,0,0-.23-.57L2.92,7.4,8.45,1.87a.81.81,0,0,0,0-1.15L8,.24A.8.8,0,0,0,7.39,0a.78.78,0,0,0-.57.24L.24,6.82A.78.78,0,0,0,0,7.4Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left_arrow.46c1db206f8baf7cfbd93680d0728c51.svg";
export { ForwardRef as ReactComponent };